export default "__VITE_ASSET__b3827f66__"